import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, updateFoodPrinter } from '../../actions/orderActions';
import BaseModal from '../../components/common/base-modal'
import ModalHeader from '../../components/common/base-modal/ModalHeader'
import { MODAL_KEYS } from '../../constants';
import useModal from '../../hooks/useModal';
import { useTranslation } from 'react-i18next';

import { getPrinterByIndex } from '../../utils'

const ModalTableQrcodePrinter = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isOpen, toggleModal } = useModal(MODAL_KEYS.tableQrcodePrinter);
    const printerSelectData = useSelector(state => state.OrderReducer.printerSelectData);
    const foodDetails = printerSelectData?.foodDetails;

    const handleSelectPrinter = printer => {
        if (printerSelectData.idInCart) {
            dispatch(updateFoodPrinter({
                printer,
                idInCart: printerSelectData.idInCart
            }));
        } else {
            const foodData = {
                ...printerSelectData,
                printerSelected: printer,
                printerIp: printer.number + ""
            };

            dispatch(addToCart([ foodData ]));
        }
        toggleModal(false);
    }

    if (!foodDetails) {
        return null;
    }

    const printerIndexes = (foodDetails?.printers || '').replace(/\(|\)|\[|\]|-.+/g, '').split(';');
    const printers = printerIndexes.map(index => getPrinterByIndex(+index)).filter(Boolean);

    return (
        <BaseModal
            isOpen={isOpen}
            contentClassName="modal-table-qrcode-question"
            onRequestClose={() => toggleModal(false)}
            centered
        >
            <ModalHeader onClose={() => toggleModal(false)}>
                {t('tableQrcodePrinter.title')}
            </ModalHeader>
            <div
                className="answer-list paragraph-2 mt-4"
            >
                {printers.map((printer, index) => (
                     <div
                        key={index}
                        onClick={() => handleSelectPrinter(printer)}
                        className="answer-item"
                    >
                        {printer.name}
                    </div>
                ))}
            </div>
        </BaseModal>
    )
}

export default ModalTableQrcodePrinter
